export const statusList = [
    { label: '全部', value: null },
    { label: '未发送', value: '0' },
    { label: '已发送', value: '1' },
    { label: '已取回', value: '2' },
]